import React, {Component} from 'react';
import {Nav, NavItem} from "reactstrap";
import {NavLink} from "react-router-dom";
import appRoutes from "appRoutes";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import NavigationAdmin from './NavigationAdmin';
import {connect} from "react-redux";

class NavigationAdminUsers extends Component {
  render() {
    const {user} = this.props;

    return (
      <Nav className="navbar-nav m-0 mx-lg-5 align-items-lg-baseline w-50 w-lg-100 float-right d-inline-block d-lg-flex">
        {(user.roles.includes('ROLE_SUPER_ADMIN') || user.roles.includes('ROLE_ADMIN_USER_RESPONDENTS')) && <NavItem className="py-2"><NavLink exact className="nav-link" to={appRoutes.admin.users.logins} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminUsers.logins"/><span className="sr-only"><FormattedMessage id="navigation.adminUsers.logins"/></span></NavLink></NavItem>}
        {(user.roles.includes('ROLE_SUPER_ADMIN') || user.roles.includes('ROLE_ADMIN_USER_RESPONDENTS')) && <NavItem className="py-2"><NavLink exact className="nav-link" to={appRoutes.admin.users.respondents} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminUsers.respondents"/><span className="sr-only"><FormattedMessage id="navigation.adminUsers.respondents"/></span></NavLink></NavItem>}
        {(user.roles.includes('ROLE_SUPER_ADMIN') || user.roles.includes('ROLE_ADMIN_USER_COMPANIES')) && <NavItem className="py-2"><NavLink exact className="nav-link" to={appRoutes.admin.users.companies} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminUsers.companies"/><span className="sr-only"><FormattedMessage id="navigation.adminUsers.companies"/></span></NavLink></NavItem>}
        {user.roles.includes('ROLE_SUPER_ADMIN') && <NavItem className="py-2"><NavLink exact className="nav-link" to={appRoutes.admin.users.admins} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminUsers.admins"/><span className="sr-only"><FormattedMessage id="navigation.adminUsers.admins"/></span></NavLink></NavItem>}
        {(user.roles.includes('ROLE_SUPER_ADMIN') || user.roles.includes('ROLE_ADMIN_USER_RESPONDENTS')) && <NavItem className="py-2"><NavLink exact className="nav-link" to={appRoutes.admin.users.points} onClick={() => NavigationAdmin.toggleNavbar(true)}><FormattedMessage id="navigation.adminUsers.points"/><span className="sr-only"><FormattedMessage id="navigation.adminUsers.points"/></span></NavLink></NavItem>}
      </Nav>
    );
  }
}

NavigationAdminUsers.propTypes = {
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired
  }).isRequired
};

function mapStateToProps(state) {
  return {
    user: state.user,
  }
}

export default connect(mapStateToProps)(NavigationAdminUsers);
